import { render, staticRenderFns } from "./AdvertsList.vue?vue&type=template&id=29839001&"
import script from "./AdvertsList.vue?vue&type=script&lang=js&"
export * from "./AdvertsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports